<template>
  <div class="booking-rooms-overview container" :class="[{'--modify-booking-mode':isBookingEditMode}]">
    <div v-if="isBookingEditMode && bookingReady">
    <modify-edit-banner
      :isRoomOverview="true"/>
    </div>
    <div class="booking-rooms-overview-header">
      <h6 class="title">{{tc('booking.roomOverviewTitle')}}</h6>
      <p class="subtitle">{{tc('booking.roomOverviewSubtitle')}}</p>
    </div>
    <div class="booking-rooms-overview-body">
      <room-overview-card
        v-for="(stay, i) in itemsInCart"
        :key="stay.id"
        :stay="stay"
        :index="i + 1"
      />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import RoomOverviewCard from './components/room-overview-card.vue'
  import ModifyEditBanner from '../../components/modify-edit-banner/modify-edit-banner.vue'
  import Tracking from '@mixins/tracking'

  export default {
    name: 'rooms-overview',
    mixins: [Tracking],
    components: {
      RoomOverviewCard,
      ModifyEditBanner
    },
    computed: {
      ...mapState('booking', { bookingReady: 'ready' }),
      ...mapState('modifyReservation', ['isBookingEditMode']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('cart', ['itemsInCart']),
      ...mapGetters('booking', ['getQuery', 'bookingFlow']),
    },
    mounted() {
      this.updateFooterLabel()
      window.dispatchEvent(new Event('rooms-overview'))

      this.$track(this.getTrackingData(this.isBookingEditMode ? 'modifyReservation' : 'booking', this.getQuery, {
        event: 'bookingStateChange',
        bookingEngine: {
          bookingStepNumber: this.isBookingEditMode ? '1.3' : '2.3',
          bookingStepName: 'Preconfirmation Page',
          bookingEngineVersion: this.isBookingEditMode ? '2' : '1',
          bookingFlow: this.bookingFlow()
        }
      }))
      
      if (window.adobe?.target?.triggerView) {
        window.adobe.target.triggerView('Preconfirmation Page')
      }
    },
    watch: {
      bookingReady(val) {
        if (val) {
          this.updateFooterLabel()
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(async vm => {
        if (vm.bookingReady) {
          await vm.updateFooterLabel()
        }
        return true
      })
    },
    methods: {
      ...mapActions('booking', ['updateNextStepButton']),
      async updateFooterLabel() {
        const label = this.tc('booking.confirm')
        await this.updateNextStepButton({ label, step: 1, customClass: 'continue' })
      }
    }
  }
</script>
